import React from 'react';
import FeatureReminderModal from './FeatureReminderModal';

type AspectRatioReminderProps = {
  isVisible: boolean;
  onPressContinue: () => void;
};

const AspectRatioReminder: React.FC<AspectRatioReminderProps> = ({
  isVisible,
  onPressContinue
}) => (
  <FeatureReminderModal
    isVisible={isVisible}
    onPressContinue={onPressContinue}
    imageSrc="/img/feature-reminders/aspect-ratio.gif"
    title="Transition to Portrait Mode for Event Cover Photos"
    description="Notice anything different? We've moved to portrait mode (4:5) for event cover photos. Make sure yours lines up."
  />
);

export default AspectRatioReminder;
